var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext } from 'react';
import Oauth from '../providers/Auth0Provider/Auth0Provider';
import { API_PROFILE } from '../helpers/api';
import { checkSessionTimeout } from '../environment.vars';
import { checkAppStatus } from '../request/checkAppStatus';
import { CentralProviderContext } from '../centralProviderContext/CentralProviderContext';
import { expiredSession } from '../helpers/expiredSession';
import { loggerError, loggerOk } from '../helpers/Log';
import { AuthContext } from '../authContext/AuthContext';
export function useCheckSession() {
    var _this = this;
    var _a = useContext(CentralProviderContext), setSessionExpired = _a.setSessionExpired, application = _a.application, setAppStatus = _a.setAppStatus;
    var setAuthResult = useContext(AuthContext).setAuthResult;
    var checkSession = function () {
        var interval = setInterval(function () {
            if (expiredSession()) {
                setSessionExpired(true);
                return;
            }
            Oauth.checkSession()
                .then(function (auth) { return __awaiter(_this, void 0, void 0, function () {
                var e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            loggerOk('success sessionAuth result', auth);
                            loggerOk('JWT-Auth', "".concat(auth.idToken));
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, fetch("".concat(API_PROFILE, "?application=").concat(application, "&expires_in=").concat(auth.expiresIn), {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: "Bearer ".concat(auth.accessToken),
                                        'JWT-Auth': "".concat(auth.idToken),
                                    },
                                })];
                        case 2:
                            _a.sent();
                            setAuthResult(auth);
                            // Check if app is online
                            checkAppStatus(application).then(function (response) {
                                setAppStatus(response, application);
                            });
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            loggerError('Error renewing Auth0 Token', e_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (e) {
                loggerError('error getting sessionAuth result', e);
                clearInterval(interval);
                setSessionExpired(true);
            });
        }, checkSessionTimeout * 60 * 1000);
    };
    return checkSession;
}
//# sourceMappingURL=useCheckSession.js.map